import { fromJS } from 'immutable';
import { initialReq, SVC_TYPE } from '@constants/common';
import { TABLE_STATE } from '@constants/actions';

const generateTableInitialState = () => {
  let initialState = fromJS({});
  Object.values(SVC_TYPE).forEach(type => {
    initialState = initialState.set(type, initialReq);
  });
  return initialState;
};

const initialState = generateTableInitialState();

const TableState = (state = initialState, action) => {
  switch (action.type) {
    case TABLE_STATE.CHANGE:
      const service = action.payload.service;
      const newTableState = state.get(service);
      return state.set(service, { ...newTableState, ...action.payload.state });
    case TABLE_STATE.RESET:
      if (action.payload?.service) {
        return state.set(action.payload.service, { ...initialReq });
      } 
      return generateTableInitialState();
        
        
    default:
      return state;
  }
};

export default TableState;